import { ContainerModule } from 'inversify';
import BrandsService from 'src/features/brands/data/service/BrandsService';
import BrandsRepository from 'src/features/brands/data/BrandsRepository';
import GetBrandsUseCase from 'src/features/brands/domain/useCases/GetBrandsUseCase';
import { BrandsServiceInterface } from 'src/features/brands/data/service/BrandsService.types';
import { BrandsRepositoryInterface } from 'src/features/brands/domain/BrandsRepositoryInterface';

export const brandsBindings = new ContainerModule((bind) => {
  bind<BrandsServiceInterface>(BrandsService).to(BrandsService);
  bind<BrandsRepositoryInterface>(BrandsRepository).to(BrandsRepository);
  bind<GetBrandsUseCase>(GetBrandsUseCase).to(GetBrandsUseCase);
});
